import React from 'react';

// Import required components
import { Heading, Tour } from '../../../components';
import { tours } from '../../../constants';
import { getPopular } from '../../../utils';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Tours = () => { 

  const popular = getPopular(tours); // Get the Popular Tours from the tours array
  const popularTours = popular.slice(0, 6); // Selecting only the top 6 popular tours

  return (
    <section className='tours'>

      {/* Section heading */}
      <Heading title={'Popular Tours'} subTitle={'Explore Our Adventure Tours'} />

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          991: { slidesPerView: 3 }, // 3 slides for larger screens
        }}

      >
        
        {/* Map over the tours array to render each tour */}
        {popularTours.map((tour) => { 
          return (
            <SwiperSlide key={tour.id}>

              {/* Render individual tour component */}
              <Tour tour={tour} />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Tours;